import Event, { IEventDispatcher } from './Event'

export const enum Direction {
  Up = 'u',
  Down = 'd',
  Left = 'l',
  Right = 'r',
  None = ''
}

interface SwipeHelperEvents {
  swiped: Event<SwipeHelper, Direction>
}

export default class SwipeHelper implements IEventDispatcher<SwipeHelper, SwipeHelperEvents> {
  events: SwipeHelperEvents = Event.list(this, 'swiped')

  static instance: SwipeHelper

  static init() {
    return new SwipeHelper()
  }

  constructor() {
    if (SwipeHelper.instance) return SwipeHelper.instance
    SwipeHelper.instance = this

    this.init()
  }

  init() {
    this.detectSwipe(d => this.onSwipe(d))
    this.detectKeys(d => this.onSwipe(d))
  }

  onSwipe(direction: Direction) {
    this.events.swiped.dispatch(direction)
  }

  private detectKeys(func: (direction: Direction) => void) {
    document.addEventListener('keyup', (event) => {
      // tslint:disable-next-line: deprecation
      const key = event.keyCode

      if (key === 37) func(Direction.Left)
      else if (key === 38) func(Direction.Up)
      else if (key === 39) func(Direction.Right)
      else if (key === 40) func(Direction.Down)
    })
  }

  private detectSwipe(func: (direction: Direction) => void) {
    const element = document
    const swipeDelta = { sX: 0, sY: 0, eX: 0, eY: 0 }
    const minX = 30  //min x swipe for horizontal swipe
    const maxX = 30  //max x difference for vertical swipe
    const minY = 50  //min y swipe for vertical swipe
    const maxY = 60  //max y difference for horizontal swipe
    let direction: Direction
    element.addEventListener('touchstart', e => {
      const t = e.touches[0]
      swipeDelta.sX = t.screenX
      swipeDelta.sY = t.screenY
    }, false)
    element.addEventListener('touchmove', e => {
      e.preventDefault()
      const t = e.touches[0]
      swipeDelta.eX = t.screenX
      swipeDelta.eY = t.screenY
    }, false)
    element.addEventListener('touchend', e => {
      //horizontal detection
      if ((
        (
          (swipeDelta.eX - minX > swipeDelta.sX) ||
          (swipeDelta.eX + minX < swipeDelta.sX)
        ) && (
          (swipeDelta.eY < swipeDelta.sY + maxY) &&
          (swipeDelta.sY > swipeDelta.eY - maxY) &&
          (swipeDelta.eX > 0)
        )
      )) {
        if(swipeDelta.eX > swipeDelta.sX) direction = Direction.Right
        else direction = Direction.Left
      }
      //vertical detection
      else if ((
        (
          (swipeDelta.eY - minY > swipeDelta.sY) ||
          (swipeDelta.eY + minY < swipeDelta.sY)
        ) && (
          (swipeDelta.eX < swipeDelta.sX + maxX) &&
          (swipeDelta.sX > swipeDelta.eX - maxX) &&
          (swipeDelta.eY > 0)
        )
      )) {
        if(swipeDelta.eY > swipeDelta.sY) direction = Direction.Down
        else direction = Direction.Up
      }

      if (direction !== '') {
        func(direction)
      }
      direction = Direction.None
      swipeDelta.sX = 0; swipeDelta.sY = 0; swipeDelta.eX = 0; swipeDelta.eY = 0
    }, false)
  }
}
